import { useEffect, useRef, RefObject } from 'react';

export function useClickOutside<T extends HTMLElement>(
  enabled: boolean,
  onClickOutside: () => void,
  excludeRefs: RefObject<HTMLElement | null>[] = []
): RefObject<T | null> {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClick = (event: MouseEvent) => {
      const target = event.target as Node;
      if (ref.current?.contains(target)) return;
      for (const excludeRef of excludeRefs) {
        if (excludeRef.current?.contains(target)) return;
      }
      onClickOutside();
    };

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [enabled, excludeRefs, onClickOutside]);

  return ref;
}
